<template>
  <div style="padding: 20px;">
    <el-form :inline="true" :model="params" class="demo-form-inline">
      <el-form-item label="查询范围">
        <el-select v-model="params.type" clearable placeholder="请选择">
          <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="卡批次号" v-if="params.type === 2">
<!--        <el-input v-model="params.parentId" placeholder="请输入"></el-input>-->
        <el-select v-model="params.parentId" filterable allow-create placeholder="请选择">
          <el-option
              v-for="item in cardUserList"
              :key="item.mdlOrder"
              :label="showCardUserLabel(item)"
              :value="item.mdlOrder">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="卡批次备注" v-if="params.type === 2">
        <el-input v-model="params.remark" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="使用用户" v-if=" params.type === 2 || params.type === 3">
        <el-select v-model="params.useUserId" filterable allow-create placeholder="请选择">
          <el-option
              v-for="item in miniProgramUserList"
              :key="item.id"
              :label="showMiniProgramUserLabel(item)"
              :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="openBarChart">查看柱状图</el-button>
      </el-form-item>
    </el-form>
    <BarStackChart :chartData="chartData" />
  </div>
</template>

<script>

import BarStackChart from '@/components/BarChart/index.vue';
import {
  analyzeOrderDataApi, getXiTunBaoCardListApi
} from "@/api/backend/xitunbaoApi";

export default {
  name: 'XiTunBaoDataAnalysis',
  components: {BarStackChart},
  data() {
    return {
      barDialogVisible: false,
      barData: null,
      params: {
        type: 1,
        startCreateTime: '',
        endCreateTime: '',
        userId: '',
        useUserId: '',
        parentId: 'C2024011120220174536',
        remake: '2024.1.30 杭州上城区小洁设计工作室购买 单卡价格375',
        cardUser: [{
          parentId: '',
          remark: ''
        }]
      },
      typeList: [
        {
          value: 1,
          label: '全部订单'
        },
        {
          value: 2,
          label: '卡批次订单'
        },
        {
          value: 3,
          label: '个人订单'
        }
      ],
      cardUserList: [],
      miniProgramUserList: [],
      chartData: {}
    };
  },
  mounted() {
    this.getCardUserList();
    this.openBarChart();
  },
  methods: {
    async openBarChart() {
      if (this.params.type === 1) {
        this.params = {
          startCreateTime: this.params.startCreateTime,
          endCreateTime: this.params.endCreateTime,
          type: this.params.type,
        }
      } else if (this.params.type === 2) {
        this.params = {
          type: this.params.type,
          startCreateTime: this.params.startCreateTime,
          endCreateTime: this.params.endCreateTime,
          userId: '',
          useUserId: '',
          parentId: this.params.parentId,
          remake: this.params.remake,
          cardUser: [{
            parentId: this.params.parentId,
            remake: this.params.remake
          }]
        }
      } else if (this.params.type === 3) {
        this.params = {
          startCreateTime: this.params.startCreateTime,
          endCreateTime: this.params.endCreateTime,
          type: this.params.type,
          userId: '',
          useUserId: this.params.useUserId,
          cardUser: []
        }
      } else {
        this.params = {}
      }

      let res = await analyzeOrderDataApi(this.params);
      if (res.code === 200) {
        this.chartData = res.data;
      /*if (res.code === 200) {
        const d = res.data;
        this.barData = {
          title: '订单数据统计',
          xAxisData: d.xAxisData,
          series: d.series.map(item => ({
            name: item.name,
            data: item.data,
            stack: item.stack
          }))
        };*/
      } else {
        this.$message.error(res.data.msg || '数据加载失败');
      }

    },
    async getCardUserList() {
      const cardUserParams = {
        current: 1,
        size: 999999
      };
      let {data} = await getXiTunBaoCardListApi(cardUserParams);
      this.cardUserList = data.rows;
    },
    showMiniProgramUserLabel (miniProgramUserItem) {
      return `${miniProgramUserItem.nickName}-${miniProgramUserItem.phone}`;
    },
    showCardUserLabel(cardUserItem) {
      // ${cardUserItem.mdlOrder}-
      return `${cardUserItem.remark}-${cardUserItem.cardName}`;
    }
  },

  /*created() {
    this.getCardUserList();
  }*/
}
;
</script>

<style>
/* 父组件样式 */
</style>